import { BreadcrumbService } from 'ng2-breadcrumb/ng2-breadcrumb';
import { TranslateService } from '@ngx-translate/core';
import { Injectable } from '@angular/core';

@Injectable()
export class BreadcrumbsService {

  constructor(
    private translateService: TranslateService,
    private breadcrumbsService: BreadcrumbService
  ) { }

  /**
   * Tłumaczy okruszki w headerze
   * 
   * @param {string} url 
   * @param {string} key 
   * @memberof BreadcrumbsService
   */
  translateBreadcrumb (url: string, key: string): void {
    this.translateService.get(key).subscribe(
      (res: string) => {
        this.breadcrumbsService.addFriendlyNameForRoute(url, res);
      }
    );
  }

  /**
   * Tłumaczy okruszki w headerze
   * 
   * @param {string} url 
   * @param {string} key 
   * @memberof BreadcrumbsService
   */
  translateBreadcrumbWithRegex (url: string, key: string): void {
    this.translateService.get(key).subscribe(
      (res: string) => {
        this.breadcrumbsService.addFriendlyNameForRouteRegex(url, res);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/services/breadcrumbs.service.ts